<template>
  <service :image="image" :title="title" :position="'center center'" data-aos="fade">
    <h1 class="hidden">{{title}}</h1>
    <p>Welcome to Chef Naturelle’s home delivery service!</p>
    <p>Set up in response of COVID-19 to support the local community, I deliver gourmet and vibrant food to your door.
      With a menu changing weekly, the dishes are designed to excite your tastebuds while nourishing your body
      and mind.</p>
    <p>The food is PLANT-BASED, free of refined sugars and focuses on ORGANIC, SEASONAL and WHOLESOME ingredients -
      using only the best quality produce paired with creative preparation methods. The produce is primarily sourced
      from LOCAL farms and plastic-free shops as well as my own allotment and I use reusable and
      compostable packaging.</p>
    <p>I donate one meal each week to someone who needs it in Hertford, a NHS worker, the elderly, the homeless.</p>
    <p>Deliveries are every Friday in Hertford, FREE OF CHARGE and collections may be available upon request.</p>
    <p>Click <a href="mailto:contact@chefnaturelle.com?subject=Next week’s home delivery menu">here</a> to request
      next week’s menu and information on how to place an order. I look forward to cooking for you!</p>
  </service>
</template>

<script>
import Service from '@/components/Service'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    Service,
  },
  data: () => ({
    image: require(`@/assets/images/deliveries.jpg?vuetify-preload`),
    title: 'Home Deliveries',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  }
}
</script>

<style lang="scss" scoped>
h1 {
  color: #0096FF;
}

a {
  font-weight: bold;
}
</style>
